import './cart.styles.css';
import '../../assets/App.scss';
import '../../assets/globalStyles.css';
import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import CardDetailOrder from '../../component/CardDetailOrder';
import FooterCartMenu from '../../component/FooterCartMenu';
import Navbar from '../../component/Navbar';
import moment from 'moment';
import {deeplinkMall, loadState, mallDefinition, numberWithCommas, saveState} from '../../_helpers';
import {cashbackServices, paymentServices} from '../../_services';
import Loading from "../../component/Loading"
import Layout from '../../component/Layout';
import {faChevronRight, faInfo, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as bulmaToast from "bulma-toast";
import logoGopay from "../../assets/logo_gopay.jpg";
import {isEmpty} from "lodash";
import axios from "axios";

function Cart({...props}) {
    let navigate = useNavigate();
    const [timeOut, setTimeOut] = useState(0)
    const [eWallet, setEWallet] = useState('Emoney');
    const [cart, setCart] = useState([]);
    const [modalConfirmation, setModalConfirmation] = useState("");
    const [modalVouhcer, setModalVouhcer] = useState("")
    const [voucherList, setVoucherList] = useState([])
    const [counter, setCounter] = useState(5);
    const [loading, setLoading] = useState(false);
    const [noteGlobal, setNoteGlobal] = useState(loadState('noteGlobal'));
    const [balance, setBalance] = useState();
    const [errBalance, setErrBalance] = useState()
    const [messageCashback, setMessageCashback] = useState(null)
    const [payloadTransactionCashback, setPayloadTransactionCashback] = useState(null)

    useEffect(() => {
        window.scrollTo(0, 0)
        const itemCart = loadState("cart");
        const voucher = loadState("voucher");
        if (voucher !== undefined && voucher !== null) {
            setVoucherList(voucher)
        }
        setLoading(true)
        paymentServices.checkBalance(loadState('cardNumber'), loadState('memberType')).then(res => {
            setBalance(res.message)
            setLoading(false)
        }).catch(err => {
            setErrBalance(err.data.message)
            setLoading(false)
        })

        setCart(itemCart)
    }, [])

    const handleUpdate = (ele) => {
        saveState('item-tenant', ele)
        navigate("/detail?id=" + ele._id + "&category=" + loadState('tenantCategory'))
    }

    const handleDecrease = (id) => {
        let oldItem = cart.find(({item_id}) => item_id === id);
        let itemIndex = cart.findIndex(x => x.item_id === id);
        cart[itemIndex] = Object.assign({}, oldItem, {quantity: oldItem.quantity - 1})
        let newUpdate = cart[itemIndex].quantity === 0 ? cart.filter(p => p.item_id !== id) : cart
        saveState('cart', newUpdate)
        setCart(loadState('cart'))
    }

    const handleIncrease = (id) => {
        let oldItem = cart.find(({item_id}) => item_id === id);
        let itemIndex = cart.findIndex(x => x.item_id === id);
        cart[itemIndex] = Object.assign({}, oldItem, {quantity: (oldItem.quantity + 1)});
        saveState('cart', cart)
        setCart(loadState('cart'))
    }

    /**
     * kalkulasi total belanja dari cart
     * */
    const total = cart !== undefined ? cart.reduce((acc, curValue) => acc + Math.round(curValue.item_price) * curValue.quantity, 0) : 0

    /**
     * kalkulasi total voucher belanja dari cart
     * */
    const totalVoucher = voucherList?.reduce((acc, curValue) => acc + curValue.voucherAmount, 0)
    const totalWithVoucher = voucherList?.length !== 0 ? (total - totalVoucher <= 0 ? 0 : total - totalVoucher) : total

    useEffect(() => {
        if (total !== 0) {
            const cashbackPayload = {
                locID: loadState('locationId'),
                custCode: "MEMBER",
                transId: "",
                refNo: loadState('cardNumber'),
                transDate: moment().format('DD/MM/yyyy'),
                amount: total,
                items: loadState('cart')?.map(val => ({
                    "itemCode": val.code,
                    "price": Math.round(val.item_price) * Number(val.quantity)
                }))
            }

            cashbackServices.getCashback(cashbackPayload).then(res => {
                setMessageCashback(null)
                if (isEmpty(res)) return false
                if (res[0].sts !== '1' && total >= res[0].purchaseAmount) {
                    setPayloadTransactionCashback(res[0])
                    setMessageCashback([{
                        msg: "Potensi Cashback",
                        sts: 2,
                        cashback: res[0].cashback,
                    }])
                } else if (res[0].sts === '3') {
                    setMessageCashback([{
                        msg: `Tambah Rp. ${numberWithCommas(res[0].minAmount)} untuk mendapatkan cashback`,
                        sts: 3,
                        cashback: 0,
                    }])
                }

            }).catch(err =>{
                axios.get('https://api.telegram.org/bot437205161:AAEl0E6xpam7r5MUUgyUd_AQcvl4rchUp_0/sendMessage?chat_id=176497627&text='+ err + 'PAYLOAD CASHBACK = ' + JSON.stringify(cashbackPayload)).then()
            })
        }
    }, [total])

    const transactionCallback = () => {
        let today = moment().format("DD/MM/YYYY")
        let memberName = loadState('memberName').split("%20").join(" ")
        let memberId = loadState('memberId').replace(/"/g, '')
        let cardNumber = loadState('cardNumber').replace(/"/g, '')
        let tableNo = loadState('tableNo').replace(/"/g, '')
        let locCode = loadState('locCode').replace(/"/g, '')
        let tenantName = loadState('tenantName').replace(/%20/g, ' ');
        let sequenceNumber = Math.floor(1000 + Math.random() * 9000);
        let order_id = 'SO-' + locCode + '-' + cardNumber + '-' + moment().format("YYMMDD") + '-' + sequenceNumber;
        // let voucherTrackingNumber = voucherList?.map(ele => ele.trackingNumber).join(', ');
        let item = [];

        // eslint-disable-next-line array-callback-return
        loadState('cart').map(val => {
            item.push({
                itemId: val._id,
                itemCode: val.code,
                description: val.description,
                qty: val.quantity,
                itemPrice: val.item_price,
                discount: "0",
                discountId: "",
                taxId: ""
            })
        })
        let itemGopay = []
        loadState('cart').map(val =>
            itemGopay.push({
                "id": val._id,
                "itemCode": val.code,
                "price": Math.round(val.item_price),
                "quantity": val.quantity,
                "description": val.description,
                "name": val.item_name,
                "brand": "AEON Mall",
                "category": val.kategori_desc,
                "merchant_name": tenantName
            }))
        let payloadPayment = {
            transaction_details: {
                order_id: order_id,
                gross_amount: Math.round(total),
                saldo: balance.balance
            },
            "item_details": itemGopay,
            "customer_details": {
                "first_name": memberName,
                "email": memberId,
                "shipping_address": {
                    "first_name": tableNo,
                    "last_name": noteGlobal === undefined ? "" : noteGlobal
                }
            },
            "payment_type": "gopay",
            "gopay": {
                "enable_callback": true,
                "callback_url": "aeon://ami_mall_app/deeplink?mall=" + deeplinkMall(loadState('memberType'))
            },
            "callbacks": {
                "finish": "https://a1.omipos.id:98/#/result?payment=gopay&code=200&message=gopay",
                "unfinish": "https://a1.omipos.id:98/#/result?payment=gopay&code=400&message=gopay",
                "error": "https://a1.omipos.id:98/#/result?payment=gopay&code=400&message=gopay"
            },
            "custom_field1": cardNumber,
            "custom_field2": tenantName,
            "custom_field3": mallDefinition(loadState('memberType'))
        }
        switch (eWallet) {
            case "Emoney":
                payloadPayment.payment_type = "IEMS"
                payloadPayment.voucher = voucherList.map(e => ({
                    soNumber: order_id,
                    approvalNo: "",
                    confirmBy: cardNumber,
                    voucherId: e.productId,
                    referenceNo: e.productId,
                    bankIssuer: "VOUCHER",
                    traceNo: "",
                    ptermId: "",
                    terminalId: "",
                    ptypeCode: "VOUCHER",
                    paymentAmount: e.voucherAmount,
                }))
                if (payloadTransactionCashback !== null) {
                    payloadPayment.cashback = [{
                        soNumber: order_id,
                        approvalNo: "",
                        confirmBy: cardNumber,
                        cashbackId: payloadTransactionCashback.cashbackId,
                        bankIssuer: "CASHBACK",
                        traceNo: "",
                        ptermId: "",
                        terminalId: "",
                        ptypeCode: "CASHBACK",
                        paymentAmount: payloadTransactionCashback.cashback,
                    }]
                }
                paymentServices.iemsPayment(loadState('memberType'), payloadPayment).then(retVal => {
                    if (payloadTransactionCashback !== null) {
                        cashbackServices.transCashback({
                            transId: order_id,
                            custCode: "MEMBER",
                            refNo: cardNumber,
                            transDate: today,
                            cashbackId: payloadTransactionCashback.cashbackId,
                            cashbackAmount: payloadTransactionCashback.cashback,
                            transAmount: total
                        }).then()
                    }
                    setLoading(false)
                    navigate(`/result?order_id=${order_id}&transaction_status=success&status_code=200`)
                    saveState('status', "success")
                    localStorage.removeItem('cart');
                    localStorage.removeItem('tenantName');
                    localStorage.removeItem('item-tenant');
                }).catch(err => {
                    navigate(`/result?order_id=${order_id}&transaction_status=${err.data.message}&status_code=${err.status}`)
                    saveState('status', "failed")
                    setLoading(false)
                })
                break;
            case "Gopay":
                paymentServices.midtransPayment(loadState('memberType'), payloadPayment).then(res => {
                    setLoading(false)
                    window.location.href = res.message.actions[1].url
                    localStorage.removeItem('cart');
                    localStorage.removeItem('tenantName');
                    localStorage.removeItem('item-tenant');
                }).catch(err => {
                    axios.get('https://api.telegram.org/bot437205161:AAEl0E6xpam7r5MUUgyUd_AQcvl4rchUp_0/sendMessage?chat_id=176497627&text=' + 'ERROR = ' + err).then()
                    setLoading(false)
                })
                break;
            default:
                break;
        }


    }

    const intervalRef = useRef(null);
    const handlePay = () => {
        setModalConfirmation('is-active');
        if (intervalRef.current !== null) {
            return;
        }
        intervalRef.current = setInterval(() => {
            setCounter(c => {
                if (c > 0) {
                    return c - 1
                } else {
                    stop()
                    setLoading(true)
                    transactionCallback()
                }
            });
        }, 1000);
    }
    const stop = () => {
        setCounter(5);
        if (intervalRef.current === null) {
            return;
        }
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }

    const TenantSelect = (c) => {
        let memberName = loadState('memberName').replace(/%20/g, ' ')
        let sessionId = loadState('sessionId').replace(/"/g, ' ')
        let memberType = loadState('memberType').replace(/"/g, ' ')
        let memberGroup = loadState('memberGroup').replace(/"/g, ' ')
        let memberId = loadState('memberId').replace(/"/g, '')
        let cardNumber = loadState('cardNumber').replace(/"/g, '')
        let tableNo = loadState('tableNo').replace(/"/g, '')
        let locCode = loadState('locCode').replace(/"/g, '')
        let tenantName = loadState('tenantName').replace(/%20/g, ' ');
        navigate(
            '/menu?locId=' + locCode +
            '&name=' + tenantName +
            '&locationCode=' + locCode +
            '&cardNumber=' + cardNumber +
            '&sessionId=' + sessionId +
            '&memberId=' + memberId +
            '&memberType=' + memberType +
            '&memberGroup=' + memberGroup +
            '&tableNo=' + tableNo,
            '&memberName=' + memberName)
    }

    const selectVoucher = () => {
        if (eWallet !== "Emoney") {
            return bulmaToast.toast({
                message: `<p align="center">Voucher tidak bisa digunakan dengan metode pembayaran gopay. <br/><br/> Lanjutkan pembayaran dengan total Rp. ${numberWithCommas(total)}</p>`,
                type: "is-warning",
                toastOnce: false,
                position: "center",
            })
        } else {
            return navigate("/voucher-list")
        }
    }

    const cancelVoucher = () => {
        const newVoucher = voucherList.filter(ele => ele.productCode !== modalVouhcer.id)
        setVoucherList(newVoucher);
        saveState('voucher', newVoucher);
        setModalVouhcer("")
    }

    return (
        <Layout>
            <Navbar title="Keranjang"/>
            <div className="container px-2 py-2 has-background-white">
                <div className="level is-mobile text-bold is-size-5 m-0">
                    {loading ? <Loading/> : errBalance !== undefined ? <p className="has-text-danger">{errBalance}</p> :
                        <>
                            <div className="level-left">
                                <div className="level-item">
                                    <p className="pink">Saldo saat ini</p>
                                </div>
                            </div>
                            <div className="level-right">
                                <p className="has-text-black">Rp {balance !== undefined ? numberWithCommas(balance.balance) : 0}</p>
                            </div>
                        </>
                    }
                </div>
                <hr/>
                <p className="is-size-5 py-1">
                    <strong>
                        Pesanan
                    </strong>
                </p>
                {cart !== undefined && cart.length > 0 ? cart.map((c, i) => (
                        <CardDetailOrder
                            key={i + 1}
                            food={c.item_name}
                            option={c.description}
                            extra={""}
                            price={c.itm_price_fmt}
                            quantity={c.quantity}
                            handleUpdate={() => handleUpdate(c)}
                            handleIncrease={() => handleIncrease(c.item_id)}
                            handleDecrease={() => handleDecrease(c.item_id)}
                        />
                    )) :
                    <article className="message is-danger">
                        <div className="message-body">
                            Wah keranjang anda <strong>kosong</strong>, Ayo belanja sekarang juga!
                        </div>
                    </article>}
                {cart !== undefined && cart.length > 0 ?
                    <button
                        onClick={() => TenantSelect()}
                        className="button is-fullwidth is-success is-outlined is-pulled-right mb-2">
                        Tambah Pesanan
                    </button>
                    : null}
                <br/>
                <hr/>
                <div className="level is-mobile pt-1">
                    <div className="level-left">
                        <div className="level-item">
                            <p className="font-medium">Subtotal</p>
                        </div>
                    </div>
                    <div className="level-right">
                        <p className="font-medium has-text-black"> Rp {numberWithCommas(Math.round(total))}</p>
                    </div>
                </div>
                {messageCashback === null || eWallet !== 'Emoney' ? null :
                    <div className="level is-mobile pt-1">
                        <div className="level-left">
                            <div className="level-item">
                                <p className="font-medium">{messageCashback[0]?.msg}</p>
                            </div>
                        </div>
                        <div className="level-right">
                            <p className="font-medium has-text-black">{messageCashback[0]?.sts === 2 ? "Rp." + numberWithCommas(messageCashback[0]?.cashback) : null}</p>
                        </div>
                    </div>
                }
                <p className="text-bold font-size left pb-1">Pembayaran</p>
                <div className="tabs is-left is-boxed flex-start">
                    <li>
                        <button
                            className={eWallet === 'Emoney' ? "e-wallet active" : 'e-wallet not-active'}
                            onClick={() => setEWallet('Emoney')}
                        >
                            <h6 className="text-bold is-size-6">E-Wallet</h6>
                        </button>
                    </li>
                    <li>
                        <button
                            id={'buttonPaymentGopay'}
                            className={eWallet === 'Gopay' ? "e-wallet active" : 'e-wallet not-active'}
                            onClick={() => setEWallet('Gopay')}>
                            <img className="resize" src={logoGopay} alt=""/>
                        </button>
                    </li>
                </div>

                {/*<button onClick={() => selectVoucher()}*/}
                {/*        className="button is-justify-content-space-between is-fullwidth is-active mb-3">*/}
                {/*    <span>Pilih Voucher</span>*/}
                {/*    <FontAwesomeIcon icon={faChevronRight}/>*/}
                {/*</button>*/}

                {eWallet === 'Emoney' && voucherList?.map((ele, index) => (
                    <div className="level is-mobile pt-1 mb-0">
                        <div className="level-left">
                            <div className="level-item">
                                <FontAwesomeIcon className="pink mr-2" onClick={() => setModalVouhcer({
                                    class: "is-active",
                                    id: ele.productCode
                                })} icon={faTrash}/>
                                <p className="font-medium">{ele.productName}</p>
                            </div>
                        </div>
                        <div className="level-right">
                            <p
                                className="font-medium has-text-black">
                                Rp. {numberWithCommas(ele.voucherAmount)}
                            </p>
                        </div>
                    </div>
                ))}

                {eWallet === "Emoney" &&
                <div className="level is-mobile pt-1 mb-0">
                    <div className="level-left">
                        <div className="level-item">
                            <p className="font-medium">E-Wallet</p>
                        </div>
                    </div>
                    <div className="level-right">
                        <p
                            className="font-medium has-text-black">
                            Rp {numberWithCommas(Math.round(Number(totalWithVoucher)))}
                        </p>
                    </div>
                </div>}
                <hr className="my-3"/>

                <div className="level is-mobile pt-1">
                    <div className="level-left">
                        <div className="level-item text-bold">
                            <p className="font-medium pink">TOTAL</p>
                        </div>
                    </div>
                    <div className="level-right">
                        <p
                            className="font-medium has-text-black">
                            Rp {numberWithCommas(eWallet === "Gopay" ? Math.round(total) : (total - totalVoucher) < 0 ? 0 : total - totalVoucher)}
                        </p>
                    </div>
                </div>

                <p className="pb-1">
                    <strong className="font-medium">
                        Note
                    </strong>
                </p>

                <div className="control">
                    <input value={noteGlobal} onChange={(e) => {
                        setNoteGlobal(e.target.value);
                        saveState('noteGlobal', e.target.value)
                    }}
                           className="input is-hovered" type="text"/>
                </div>
                <hr/>
                <FooterCartMenu
                    addToCart={() => {
                        let format = 'hh:mm:ss'
                        let time = moment(new Date(), format),
                            beforeTime = moment('10:00:00', format),
                            afterTime = moment('21:30:00', format);
                        if (time.isBetween(beforeTime, afterTime)) {
                        handlePay()
                        } else {
                            if (timeOut === 0)
                                bulmaToast.toast({
                                    message: '<h6 align="center" classname="bold">Pemesanan saat ini telah ditutup <br> silakan coba lagi di jam operasional 10:00 - 21:30</h6>',
                                    type: "is-danger",
                                    toastOnce: false,
                                    position: "center"
                                });

                            setTimeOut(2000)
                            setTimeout(() => {
                                setTimeOut(0)
                            }, 2000)
                        }
                    }}
                    totalPrice={numberWithCommas(eWallet === "Gopay" ? total : (total - totalVoucher) < 0 ? 0 : total - totalVoucher)}
                    title={'TOTAL'}
                    textButton={'BAYAR'}
                    disabled={cart === undefined || cart.length === 0}
                />
                {
                    eWallet === "Gopay" ? <div className={"cart-info-bottom"}>
                        <p><FontAwesomeIcon className="icon-bars" icon={faInfo} style={{marginRight: '5%'}}/> Pesanan
                            Anda tidak dapat dibatalkan
                        </p>
                    </div> : null
                }

                <div className={`modal ${modalVouhcer.class}`}>
                    <div className="modal-background"/>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title pink has-text-centered">Cancel Voucher</p>
                        </header>
                        <section className="modal-card-body">
                            <p className="py-1">Gunakan Nanti?</p>
                        </section>
                        <footer className="modal-card-foot">
                            <div className="column p-button button background-pink has-text-white"
                                 onClick={() => setModalVouhcer("")}><p>YA</p></div>
                            <div className="column p-button button" onClick={() => cancelVoucher()}><p>TIDAK</p>
                            </div>
                        </footer>
                    </div>
                </div>
                <div className={`modal ${modalConfirmation}`}>
                    <div className="modal-background"/>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title pink has-text-centered">Transaksi Diproses</p>
                        </header>
                        <section className="modal-card-body">
                            <p className="py-1">Transaksi Anda sedang di proses, klik cancel untuk menghentikan
                                proses</p>
                            {loading ? <Loading/> : <div className="number-time">{counter}</div>}
                            <button onClick={() => {
                                stop();
                                setModalConfirmation("")
                            }} style={{width: "100%", marginTop: "1rem"}}
                                    disabled={loading}
                                    className="button pay">CANCEL
                            </button>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Cart;
